<script>
    import {getPercentage, getState} from '../utils'

    export let silo;

    let state = "";
    let percentage = 0;
    let stateDisplay = "";

    $: watchEquipmentState(silo);

    function watchEquipmentState(_equipment) {
        percentage = getPercentage(_equipment) * 100;
        state = getState(_equipment, percentage);
    }

    $: watchState(state);

    function watchState(_state) {
        switch (_state) {
            case "danger":
                stateDisplay = "Low-low";
                break;
            case "warning":
                stateDisplay = "Low";
                break;
            default:
                stateDisplay = "Normal"
        }
    }
</script>

{#if silo !== undefined && silo.infos.thresholds.danger.value}
    <div class="card">
        <div class="card-body">
            <div class="card-head">
                <h2 class="card-title">Current Level</h2>

                <div class="data-progress">
                    <span class="text-{state} level">{parseFloat(silo.lastMessage.display).toFixed(2)} {silo.infos.display_units? silo.infos.display_units : silo.units}</span>
                    <div class="progress big">
                        <div class="progress-bar bg-{state}" role="progressbar"
                             style="width: {percentage}%;"
                             aria-valuenow="{percentage}" aria-valuemin="0" aria-valuemax="100">{percentage.toFixed(0)}%
                        </div>
                    </div>
                    <ul class="meter">
                        <li>0%</li>
                        <li>100%</li>
                    </ul>
                </div>

                {#if silo.infos.thresholds}
                    <div class="data-progress">
                        <h2 class="card-title">Current Thresholds</h2>
                        <div class="progress big">
                            <div class="progress-bar bg-danger" role="progressbar"
                                 style="width: {silo.infos.thresholds.danger.value}%;"
                                 aria-valuenow="{silo.infos.thresholds.danger.value}" aria-valuemin="0"
                                 aria-valuemax="100">{silo.infos.thresholds.danger.display}
                            </div>
                            <div class="progress-bar bg-warning" role="progressbar"
                                 style="width: {silo.infos.thresholds.warning.value - silo.infos.thresholds.danger.value}%;"
                                 aria-valuenow="{silo.infos.thresholds.warning.value - silo.infos.thresholds.danger.value}"
                                 aria-valuemin="0"
                                 aria-valuemax="100">{silo.infos.thresholds.warning.display}
                            </div>
                            <div class="progress-bar bg-success" role="progressbar"
                                 style="width: {100 - silo.infos.thresholds.warning.value}%;"
                                 aria-valuenow="{100 - silo.infos.thresholds.warning.value}" aria-valuemin="0"
                                 aria-valuemax="100"></div>
                        </div>

                        <ul class="meter">
                            <li>0%</li>
                            <li>100%</li>
                        </ul>

                        <div class="data-legend">
                            <ul class="list-inline text-center">
                                <li>
                                    <h6 class="text-success"><i class="fa fa-circle font-10 m-r-10 "></i>Normal
                                    </h6></li>
                                <li>
                                    <h6 class="text-warning"><i class="fa fa-circle font-10 m-r-10"></i>Low
                                    </h6></li>
                                <li>
                                    <h6 class="text-danger"><i class="fa fa-circle font-10 m-r-10"></i>Low-Low
                                    </h6></li>
                            </ul>
                        </div>
                    </div>
                {/if}
            </div>
        </div>
    </div>
{/if}